
import BasicCard from "../BasicCard";
import Dummylayout from "../Dummylayout";
import StartofYear from "./StarofYear";


function StarofYearMain() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <StartofYear/>
            </BasicCard>
        </>
    )
}
export default StarofYearMain;